import { useQuery } from '@tanstack/react-query'
import { getScriptByExtensionCollectId } from 'service/list'

function useGetPollingScript(
  extensionCollectId: number | null,
  isPolling: boolean
) {
  return useQuery({
    queryKey: ['get-script', extensionCollectId],
    queryFn: () => getScriptByExtensionCollectId(extensionCollectId),
    refetchOnWindowFocus: false,
    enabled: false,
  })
}

export default useGetPollingScript
